/* eslint semi:0 */
import { BaseStore } from './baseStore'
import dialog from '../../providers/dialogProvider'
import { safeRequest } from '../../utils/mithril'
import { TYPES } from '../actions/modalActions'
import { get } from '../../application/pageDataObject'
import { authenticated, autnenticationFailed } from '../actions/userToolbarActions'
import { localizedPath } from '../../providers/i18nProvider/i18nProvider'
import { areComponentsIdentical } from '../../utils/component'
import signupModalComponent from '../components/signupModalComponent'

const SIGNUP_PATH = get('config.signup_path')

class SignupModalStore extends BaseStore {
  routeAction(action) {
    switch (action.type) {
      case TYPES.CLOSE:
        return this.onModalDirtyClose()
    }
  }

  get languages() {
    return this.options.modalData.languages
  }

  get leagues() {
    return this.options.modalData.leagues
  }

  get localeLeague() {
    return this.options.modalData.locale_league
  }

  get localeLeagueName() {
    return this.options.modalData.locale_league_name
  }

  get teams() {
    return this.options.modalData.teams
  }

  get termsUrl() {
    return this.options.modalData.terms_url
  }

  get privacyUrl() {
    return this.options.modalData.privacy_url
  }

  get authId() {
    return this.options.authId
  }

  set isLoading(flag) {
    this.vm.isLoading(flag)
    this.vm.onChange()
  }

  set serverValidationErrors(errors) {
    this.vm.serverValidationErrors(errors)
  }

  onModalDirtyClose() {
    if (areComponentsIdentical(dialog.modal.currentComponent, signupModalComponent)) {
      return setImmediate(autnenticationFailed)
    }
  }

  submit(data) {
    let url = localizedPath(SIGNUP_PATH)

    safeRequest({
      method: 'POST',
      data,
      url,
      serialize: function(serializeData) {
        return serializeData
      },
    }).then(this.onSubmitResponse.bind(this), this.onSubmitFailed.bind(this))
    this.isLoading = true
  }

  onSubmitResponse(response) {
    this.isLoading = false
    response.errors ? this.onSubmitFailed(response) : this.onSubmitSucceed(response)
  }

  onSubmitSucceed(response) {
    response.existing = true
    authenticated(response)
    dialog.modal.close()
  }

  onSubmitFailed(response) {
    this.isLoading = false
    this.serverValidationErrors = response.errors
  }
}

export default SignupModalStore



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/SignupModalStore.js